import React, {
  useState, useImperativeHandle, forwardRef
} from 'react';
import {
  Container, Grid
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useFormContext } from 'react-hook-form';
import FormTextField from '@seccon/core/components/FormTextField';
import FormDatePicker from '@seccon/core/components/FormDatePicker';
import FormAutocomplete from '@seccon/core/components/FormAutocomplete';
import { fetchCountryOptions, fetchStateOptions } from '@seccon/shared/utils/destinationUtils';

const PassportInformationForm = forwardRef((_props, ref) => {
  const {
    control, trigger, formState: { errors }
  } = useFormContext();

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const onValidate = async () => {
    // Trigger validation for all fields
    const isValid = await trigger();
    if (isValid) {
      console.log('Validation successful');
      // Handle successful validation logic here
    } else {
      console.log('Validation failed');
      // Handle validation failure logic here
    }
    return isValid;
  };

  useImperativeHandle(ref, () => ({
    validate: async () => {
      const isValid = await onValidate();
      return isValid;
    }
  }));

  return (
    <Container>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <form>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormTextField
                control={control}
                formErrors={errors}
                label='Passport Number'
                formFieldId='foreignTravel.travelingPersonnel.passport.number'
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                control={control}
                formErrors={errors}
                label='Passport Type'
                formFieldId='foreignTravel.travelingPersonnel.passport.type'
                required
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                control={control}
                formErrors={errors}
                label='Issue Date'
                formFieldId='foreignTravel.travelingPersonnel.passport.issueDate'
                required
                views={['year', 'month', 'day']}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                control={control}
                formErrors={errors}
                label='Expiration Date'
                formFieldId='foreignTravel.travelingPersonnel.passport.expirationDate'
                required
                views={['year', 'month', 'day']}
              />
            </Grid>
            <Grid item xs={12}>
              <FormAutocomplete
                control={control}
                formErrors={errors}
                label='State of Birth'
                formFieldId='foreignTravel.travelingPersonnel.passport.stateOfBirth'
                freeSolo={false}
                options={stateOptions}
                fetchedOptions={(searchText) => fetchStateOptions(searchText, setStateOptions)}
                noOptionsText='Type to search for States'
                disableClearable={false}
              />
            </Grid>
            <Grid item xs={12}>
              <FormAutocomplete
                control={control}
                formErrors={errors}
                label='Country of Birth'
                formFieldId='foreignTravel.travelingPersonnel.passport.countryOfBirth'
                required
                freeSolo={false}
                options={countryOptions}
                fetchedOptions={(searchText) => fetchCountryOptions(searchText, setCountryOptions)}
                noOptionsText='Type to search for Countries'
                disableClearable={false}
              />
            </Grid>
          </Grid>
        </form>
      </LocalizationProvider>
    </Container>
  );
});

export default PassportInformationForm;
